import React from 'react';
import ProductTable from './_ProductTableStyles.module.scss';

const HomePageBody = (): JSX.Element => {
    return (
        <div>
            <table className={ProductTable.table}>
                <tr className={ProductTable.productAmount}>
                    <td rowSpan={2}>Product</td>
                    <td>Grab Voucher 2 Boxes</td>
                    <td colSpan={2}>Grab Voucher 4 Boxes</td>
                </tr>
                <tr className={ProductTable.productType}>
                    <td>Sphere</td>
                    <td>Sphere</td>
                    <td>Toric/Multifocal</td>
                </tr>
                <tr>
                    <td>MyDay®</td>
                    <td>$30</td>
                    <td>$65</td>
                    <td>$30</td>
                </tr>
                <tr>
                    <td>Biofinity®</td>
                    <td>-</td>
                    <td>$60</td>
                    <td>$60</td>
                </tr>
            </table>
        </div>
    );
};

export default HomePageBody;
